<template>
  <footer class="footer flex-column flex-center bg-secondary clr-white text-center px-4 font-lg">
    <div class="footer__copyright pt-1 text-uppercase">© Lycaste 2022</div>
    <div class="footer__links d-flex align-items-center line-height-1 my-1">
      <a
        class="px-3 py-1 radius-base footer__link"
        v-ripple>Terms & Conditions</a>
      <a
        class="px-3 py-1 radius-base footer__link"
        v-ripple>Privacy Policy</a>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
}
</script>

<style lang="scss" scoped>
@import '@/styles/@core/globals';

.footer {
  height: $footer-height;

  &__link {
    color: color('white');
    transition: transition('all');

    &:hover {
      color: color('white', $opacity: 8)
    }
  }
}
</style>
